import Icon from "./icon";

const PickUpPointsCard = ({ point, clinic = false, labels }) => {
  return clinic ? (
    <>
      <div className="pick-up-points__point-info-header">
        <span className="pick-up-points__point-place">{point?.city}</span> - {point?.name}
      </div>
      {(point?.website || point?.websiteLabel) && (
        <div className="pick-up-points__point-info">
          <Icon name="globe" className="globe" />
          {point?.website ? (
            <a
              target="_blank"
              rel="noreferrer"
              href={point?.website}
              className="pick-up-points__point-info-text"
            >
              {point?.websiteLabel || point?.website}
            </a>
          ) : (
            <span className="pick-up-points__point-info-text">{point?.websiteLabel}</span>
          )}
        </div>
      )}
      {point?.address && (
        <div className="pick-up-points__point-info">
          <Icon name="location-pin" className="location-pin" />
          <a
            target="_blank"
            rel="noreferrer"
            href={`http://maps.google.com/?q=${point?.address}`}
            className="pick-up-points__point-info-text"
          >
            {point?.address}
          </a>
        </div>
      )}
      {point?.phone && (
        <div className="pick-up-points__point-info">
          <Icon name="phone" className="phone" />
          <span className="pick-up-points__point-info-text">{point?.phone}</span>
        </div>
      )}
      {point?.workingHours && (
        <div className="pick-up-points__point-info">
          <Icon name="clock" className="clock" />
          <span className="pick-up-points__point-info-text">{point?.workingHours}</span>
        </div>
      )}
      {point?.notes && (
        <div className="pick-up-points__point-info">
          <Icon name="info" className="info pick-up-points__point-info-notes-icon" />
          <span className="pick-up-points__point-info-text">{point?.notes}</span>
        </div>
      )}
      {point?.notProvidedExams?.length > 0 && (
        <div className="error-box">
          <Icon name="error" />
          <div
            className="error-box__text"
            dangerouslySetInnerHTML={{
              __html: (
                labels?.WELFARE_CHECKUP_EXAMS_WARNING ||
                "<p><strong>In questo centro non sono previste le visite specialistiche:</strong> <span class=black>[EXAM]</span></p>"
              ).replace(
                "[EXAM]",
                point?.notProvidedExams
                  ?.map((exam) => exam?.name)
                  ?.join(", ")
                  ?.replace(/,([^,]*)$/, ` ${labels?.AND || "and"}$1`)
              ),
            }}
          />
        </div>
      )}
    </>
  ) : (
    <>
      <div className="pick-up-points__point-city">{point?.city}</div>
      <div className="pick-up-points__point-info">
        <Icon name="location-pin" />
        <span className="pick-up-points__point-name">{point?.name}</span> -{" "}
        <span className="pick-up-points__point-address">{point?.address}</span>
      </div>
    </>
  );
};
export default PickUpPointsCard;
